import { pick } from 'ramda';
import { TExtra } from '../../types/analytics/products';
import { IBuilder } from '../../types/newbuilding/builder';
import { IApplicationState } from '../../types/redux';
import { getNewbuildingId } from '../newbuilding';

export function getProductsData(id: number, builder: IBuilder | null, extra?: TExtra, position?: number) {
  if (!builder || !builder.phoneAnalyticsData) {
    return {
      id,
      offerType: 'JK',
      position: position || 1,
      extra,
    };
  }

  return {
    extra,
    ...pick(
      ['brand', 'nv', 'dealType', 'id', 'name', 'objectType', 'consultant', 'position'],
      builder.phoneAnalyticsData,
    ),
  };
}

export function selectDefaultProductsData(state: IApplicationState) {
  const newbuildingId = getNewbuildingId(state);

  return {
    id: newbuildingId,
    offerType: 'JK',
    position: 1,
  };
}
